import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Sort {
  field: string | null;
  order: string | null;
}
interface InitialState {
  searchText: string;
  page: number;
  limit: number;
  sort: {
    field: string | null;
    order: string | null;
  };
}

const initialState: InitialState = {
  searchText: "",
  page: 1,
  limit: 10,
  sort: {
    field: null,
    order: null,
  },
};

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.page = 1;
      state.searchText = action.payload;
    },

    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },

    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },

    setSort: (state, action: PayloadAction<Sort>) => {
      state.sort = action.payload;
    },
  },
});

export const {
  setSearchText,
  setPage,
  setLimit,
  setSort,
} = reportSlice.actions;

export const selectReport = (state: any) => state.report;

export default reportSlice.reducer;
